import { createIconComponent } from '../../factory/create-icon-component';
export const SplitIcon = createIconComponent(
  'SplitIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="5.76636"
      cy="17.7659"
      r="4"
      transform="rotate(89.8594 5.76636 17.7659)"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="5.73694"
      cy="5.76597"
      r="4"
      transform="rotate(89.8594 5.73694 5.76597)"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.7393 6.75608L22.265 17.2254"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.76511 17.2561L16.0022 11.9908M22.2393 6.72543L18.2476 10.0952"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
